export enum SQSProcessName {
    ACCOUNT_ENTITY_CHANGE = "account-entity-change",
    TRANSACTION_RULE_APPLICATION = "transaction-rule-application",
    CLONE_WORKSPACE = "clone-workspace",
    PLAID_TRANSACTION_IMPORT = "plaid-transaction-import",
    PLAID_INITIAL_TRANSACTION_IMPORT = "plaid-initial-transaction-import",
    MERCURY_ACCOUNTS_SYNC = "mercury-accounts-sync",
    MERCURY_TRANSACTION_RECEIPTS_IMPORT = "mercury-transaction-receipts-import",
    GUSTO_ACCOUNT_SYNC = "gusto-account-sync",
    ADP_RUN_ACCOUNT_SYNC = "adp-run-account-sync",
    RAMP_TRANSACTIONS_SYNC = "ramp-transactions-sync",
    RAMP_BILLS_SYNC = "ramp-bills-sync",
    RAMP_ACCOUNTS_SYNC = "ramp-accounts-sync",
    PAYPAL_SYNC = "paypal-sync",
    BILLCOM_SYNC = "billcom-sync",
    STRIPE_SYNC = "stripe-sync",
    STRIPE_INVOICES_SYNC = "stripe-invoices-sync",
    STRIPE_TRANSACTIONS_SYNC = "stripe-transactions-sync",
    INVOICE_MATCHING = "invoice-matching",
    INVOICE_NATIVE_EMAIL_SEND = "invoice-native-email-send",
    INVOICE_PDF_DOWNLOAD = "invoice-pdf-download",
    BILL_MATCHING = "bill-matching",
    FINANCIAL_ACCOUNT_MERGING = "financial-account-merging",
    UPDATE_AUDIT_LOGS = "update-audit-logs",
    EXTRACT_ACCOUNT_INFO_FROM_DOCUMENT = "extract-account-info-from-document",
    DOCUMENT_DOWNLOAD = "document-download",
    FINANCIAL_DOCUMENT_TRANSACTIONS_IMPORT = "financial-document-transactions-import",
    FINANCIAL_DOCUMENT_ACCRUAL_IMPORT = "financial-document-accrual-import",
    JOURNAL_ENTRIES_REGEN = "journal-entries-regen",
    IMPORTED_JE_TO_MJE_CONVERSION = "imported-je-to-mje-conversion",
    QBD_JSON_DOCUMENT_MIGRATION_IMPORT = "qbd-json-document-migration-import",
    QBD_JSON_ACCRUAL_DOCUMENTS_IMPORT = "qbd-json-accrual-documents-import",
    MIGRATED_JE_DESCRIPTION_GROUPING = "migrated-je-description-grouping",
    MIGRATED_JE_DESCRIPTION_NORMALIZATION = "migrated-je-description-normalization",
    MIGRATED_JE_ENRICHMENT_RULES_FINALIZATION = "migrated-je-enrichment-rules-finalization",
    MAP_IMPORTED_ACCOUNTS_TO_KICK_COA = "map-imported-accounts-to-kick-coa",
    MATCH_CATEGORIES_TO_COA_ACCOUNTS = "match-categories-to-coa-accounts",
    MATCH_CATEGORIES_TO_COA_TEMPLATE_ACCOUNTS = "match-categories-to-coa-template-accounts",
    QUICKBOOKS_JOURNAL_ENTRIES_SYNC = "quickbooks-journal-entries-sync",
    QUICKBOOKS_COUNTERPARTIES_SYNC = "quickbooks-counterparties-sync",
    QUICKBOOKS_CLASSES_SYNC = "quickbooks-classes-sync",
    QUICKBOOKS_ATTACHMENTS_SYNC = "quickbooks-attachments-sync",
    QUICKBOOKS_CATALOG_ITEMS_SYNC = "quickbooks-catalog-items-sync",
    QUICKBOOKS_INVOICES_SYNC = "quickbooks-invoices-sync",
    QUICKBOOKS_BILLS_SYNC = "quickbooks-bills-sync",
    REVALIDATE_IMPORTER_DOCUMENTS = "revalidate-importer-documents",
    CONTINUOUS_RECONCILIATION = "continuous-reconciliation",
    RECOMPUTE_IMPORTED_SETTLEMENTS = "recompute-imported-settlements",
    TASK_BULK_UPDATES = "task-bulk-updates",

    NEW_FINANCIAL_ACCOUNTS_IN_ENTITY_SIDE_EFFECT = "new-financial-accounts-in-entity-side-effect",

    FINANCIAL_BUSINESS_MATCHING = "financial-business-matching",
    TRANSACTION_TRANSFER_MATCHING = "transaction-transfer-matching",

    AUDIT_LOG_TO_CHAT = "audit-log-to-chat",
    AUDIT_LOG_ROLLBACK = "audit-log-rollback",
    DOCUMENT_SCANNING = "document-scanning",
    FINANCIAL_DOCUMENT_RECEIPT_MATCHING = "financial-document-receipt-matching",
    TRANSACTION_SIMILARITY_UPDATE = "transaction-similarity-update",
    SYNC_GOOGLE_SHEETS = "sync-google-sheets",

    TASK_CLOSE_STAGE_RECALCULATION = "task-close-stage-recalculation",
    ENTITY_THRESHOLD_RECALC = "entity-threshold-recalc",

    ACCRUAL_MATCH_BACKFILL = "accrual-match-backfill",

    CREATE_ACCRUAL_REVIEW_TASKS_FOR_ENTITY = "create-accrual-review-tasks-for-entity",
    CREATE_SCHEDULE_REVIEW_TASKS_FOR_ENTITY = "create-schedule-review-tasks-for-entity",
    SCHEDULE_RULE_SUGGEST = "schedule-rule-suggest",
    SCHEDULE_RULE_APPLY = "schedule-rule-apply",
    SCHEDULE_RECOGNITION_AUTO_POST = "schedule-recognition-auto-post",

    COUNTERPARTY_MERGE = "counterparty-merge",

    REGENERATE_DEMO_ACCOUNT = "regenerate-demo-account",

    CREATE_ORGANIZATION_DEMO_WORKSPACE = "create-organization-demo-workspace",

    PLAIN_WORKSPACE_SETUP = "plain-workspace-setup",
}

export enum CLIProcessName {
    REGENERATE_DEMO_ACCOUNTS = "cli.regenerate_demo_accounts",
    CREATE_DEMO_WORKSPACE = "cli.create_demo_workspace",
    NORMALIZE_DESCRIPTIONS = "cli.normalize-descriptions-for-historical-transactions",
    REMOVE_DEBIT_REIMBURSEMENT_SPLITS = "cli.remove-debit-reimbursement-splits",
    EXTRACT_SUGGESTED_CATEGORIES = "cli.extract_suggested_categories",
}

export enum APIProcessName {
    ACCOUNTING_WEBHOOK_OPENING_BALANCE = "accounting-webhook-opening-balance",

    GOOGLE_SHEETS_ADDON_CREATE_CONNECTION = "google-sheets-addon-create-connection",
    GOOGLE_SHEETS_ADDON_START_CONNECTION = "google-sheets-addon-start-connection",
    GOOGLE_SHEETS_ADDON_COMPLETE_CONNECTION = "google-sheets-addon-complete-connection",
    GOOGLE_SHEETS_ADDON_REUSE_CONNECTION = "google-sheets-addon-reuse-connection",
    GOOGLE_SHEETS_ADDON_CREATE_SCHEDULE = "google-sheets-addon-create-schedule",
    GOOGLE_SHEETS_ADDON_DELETE_SCHEDULE = "google-sheets-addon-delete-schedule",
    GOOGLE_SHEETS_ADDON_REFRESH_NOW = "google-sheets-addon-refresh-now",
    GOOGLE_SHEETS_ADDON_DISCONNECT = "google-sheets-addon-disconnect",
    GOOGLE_SHEETS_ADDON_OAUTH_RESULT = "google-sheets-addon-oauth-result",

    EVALS_SETUP = "evals-setup",
    EVALS_EXECUTE = "evals-execute",
    EVALS_INSPECT = "evals-inspect",
    EVALS_CLEANUP = "evals-cleanup",
    EVALS_SETUP_AND_EXECUTE = "evals-setup-and-execute",
    EVALS_RUN_TRANSFER_MATCHING = "evals-run-transfer-matching",
    EVALS_START_BATCH_ENRICHMENT = "evals-start-batch-enrichment",
    EVALS_POLL_WORKFLOWS = "evals-poll-workflows",
    EVALS_WORKFLOW_ACTIVITY_STATS = "evals-workflow-activity-stats",

    ACCOUNTING_JOURNAL_ENTRIES_CREATE = "accounting-journal-entries-create",
    ACCOUNTING_JOURNAL_ENTRIES_BULK_CREATE = "accounting-journal-entries-bulk-create",
    ACCOUNTING_JOURNAL_ENTRIES_UPDATE = "accounting-journal-entries-update",
    ACCOUNTING_JOURNAL_ENTRIES_DELETE = "accounting-journal-entries-delete",
    ACCOUNTING_UPSERT_OPENING_BALANCE = "accounting-upsert-opening-balance",
    ACCOUNTING_SET_OPENING_BALANCES_BULK = "accounting-set-opening-balances-bulk",
    ACCOUNTING_REMOVE_OPENING_BALANCE = "accounting-remove-opening-balance",

    ACCRUAL_REVIEW_APPROVE = "accrual-review-approve",
    ACCRUAL_REVIEW_REVERSE_APPROVE = "accrual-review-reverse-approve",
    ACCRUAL_REVIEW_UNDO = "accrual-review-undo",
    ACCRUAL_REVIEW_BULK_UNMATCH_INVOICES = "accrual-review-bulk-unmatch-invoices",
    ACCRUAL_MATCH_CREATE = "accrual-match-create",
    ACCRUAL_MATCH_REMOVE = "accrual-match-remove",

    ADMIN_EDIT_COUNTERPARTY = "admin-edit-counterparty",
    ADMIN_MERGE_COUNTERPARTIES = "admin-merge-counterparties",
    ADMIN_REGENERATE_WORKSPACE_JOURNAL_ENTRIES = "admin-regenerate-workspace-journal-entries",
    ADMIN_SYNC_INTEGRATION_CONNECTION = "admin-sync-integration-connection",
    ADMIN_SYNC_FINANCIAL_ACCOUNT = "admin-sync-financial-account",
    ADMIN_UPDATE_WORKSPACES = "admin-update-workspaces",
    ADMIN_UPDATE_ENTITIES = "admin-update-entities",
    ADMIN_MOVE_ENTITY_TO_WORKSPACE = "admin-move-entity-to-workspace",
    ADMIN_DELETE_ENTITY = "admin-delete-entity",
    ADMIN_CHANGE_ENTITY_BOOKKEEPING_START_DATE = "admin-change-entity-bookkeeping-start-date",
    ADMIN_SET_ENTITY_METERING_EXCLUSION = "admin-set-entity-metering-exclusion",
    ADMIN_GET_ORGANIZATIONS = "admin-get-organizations",
    ADMIN_REGISTER_ORGANIZATION_BILLING_PRICE = "admin-register-organization-billing-price",
    ADMIN_REPLACE_ORGANIZATION_BILLING_POLICY = "admin-replace-organization-billing-policy",
    ADMIN_SET_ORGANIZATION_WORKSPACE_BILLING_PRICE = "admin-set-organization-workspace-billing-price",
    ADMIN_SET_ORGANIZATION_PRORATION_BEHAVIOR = "admin-set-organization-proration-behavior",
    ADMIN_LOG_ORGANIZATION_PAYMENT_LINK = "admin-log-organization-payment-link",
    ADMIN_GET_WORKSPACES = "admin-get-workspaces",
    ADMIN_CHANGE_WORKSPACE_SUBSCRIPTION = "admin-change-workspace-subscription",
    ADMIN_MOVE_WORKSPACE_SUBSCRIPTION_TO_ORGANIZATION = "admin-move-workspace-subscription-to-organization",

    AUTH_LOGIN = "auth-login",

    MCP_CONNECTIONS_LIST = "mcp-connections-list",
    MCP_CONNECTIONS_REVOKE = "mcp-connections-revoke",

    PAT_CREATE = "personal-access-token-create",
    PAT_LIST = "personal-access-token-list",
    PAT_REVOKE = "personal-access-token-revoke",

    ORGANIZATION_ACCESS_TOKEN_GET = "organization-access-token-get",
    ORGANIZATION_ACCESS_TOKEN_ROTATE = "organization-access-token-rotate",
    ORGANIZATION_WEBHOOK_PORTAL = "organization-webhook-portal",

    PLATFORM_GET_ORGANIZATION = "platform-get-organization",
    PLATFORM_LIST_WORKSPACES = "platform-list-workspaces",
    PLATFORM_CREATE_WORKSPACE = "platform-create-workspace",
    PLATFORM_GET_WORKSPACE = "platform-get-workspace",
    PLATFORM_UPDATE_WORKSPACE = "platform-update-workspace",
    PLATFORM_DELETE_WORKSPACE = "platform-delete-workspace",
    PLATFORM_LIST_WORKSPACE_ENTITIES = "platform-list-workspace-entities",
    PLATFORM_CREATE_WORKSPACE_ENTITY = "platform-create-workspace-entity",
    PLATFORM_GET_ENTITY = "platform-get-entity",
    PLATFORM_DELETE_ENTITY = "platform-delete-entity",
    PLATFORM_UPDATE_ENTITY = "platform-update-entity",
    PLATFORM_CREATE_PLAID_CONNECTION = "platform-create-plaid-connection",
    PLATFORM_LIST_PLAID_CONNECTIONS = "platform-list-plaid-connections",
    PLATFORM_DELETE_PLAID_CONNECTION = "platform-delete-plaid-connection",
    PLATFORM_LIST_FINANCIAL_ACCOUNTS = "platform-list-financial-accounts",
    PLATFORM_UPDATE_FINANCIAL_ACCOUNT = "platform-update-financial-account",
    PLATFORM_MOVE_FINANCIAL_ACCOUNT = "platform-move-financial-account",
    PLATFORM_DELETE_FINANCIAL_ACCOUNT = "platform-delete-financial-account",
    PLATFORM_CREATE_LEDGER = "platform-create-ledger",
    PLATFORM_LIST_JOURNAL_ENTRIES = "platform-list-journal-entries",
    PLATFORM_GET_JOURNAL_ENTRY = "platform-get-journal-entry",
    PLATFORM_CREATE_JOURNAL_ENTRY = "platform-create-journal-entry",
    PLATFORM_BULK_CREATE_JOURNAL_ENTRIES = "platform-bulk-create-journal-entries",
    PLATFORM_UPDATE_JOURNAL_ENTRY = "platform-update-journal-entry",
    PLATFORM_DELETE_JOURNAL_ENTRY = "platform-delete-journal-entry",
    PLATFORM_GET_PROFIT_AND_LOSS = "platform-get-profit-and-loss",
    PLATFORM_GET_BALANCE_SHEET = "platform-get-balance-sheet",
    PLATFORM_GET_TRIAL_BALANCE = "platform-get-trial-balance",
    PLATFORM_GET_GENERAL_LEDGER = "platform-get-general-ledger",
    PLATFORM_GET_CASH_FLOW = "platform-get-cash-flow",
    PLATFORM_LIST_CHART_OF_ACCOUNTS = "platform-list-chart-of-accounts",
    PLATFORM_GET_ACCOUNT = "platform-get-account",
    PLATFORM_CREATE_ACCOUNT = "platform-create-account",
    PLATFORM_BULK_CREATE_ACCOUNTS = "platform-bulk-create-accounts",
    PLATFORM_UPDATE_ACCOUNT = "platform-update-account",
    PLATFORM_DISABLE_ACCOUNT = "platform-disable-account",
    PLATFORM_ENABLE_ACCOUNT = "platform-enable-account",
    PLATFORM_DELETE_ACCOUNT = "platform-delete-account",
    PLATFORM_MERGE_ACCOUNTS = "platform-merge-accounts",
    PLATFORM_PREPARE_CATEGORIZATION = "platform-prepare-categorization",
    PLATFORM_LIST_OPENING_BALANCES = "platform-list-opening-balances",
    PLATFORM_GET_OPENING_BALANCE = "platform-get-opening-balance",
    PLATFORM_SET_OPENING_BALANCE = "platform-set-opening-balance",
    PLATFORM_SET_OPENING_BALANCE_ADJUSTMENT = "platform-set-opening-balance-adjustment",
    PLATFORM_DELETE_OPENING_BALANCE_ADJUSTMENT = "platform-delete-opening-balance-adjustment",
    PLATFORM_DELETE_OPENING_BALANCE = "platform-delete-opening-balance",
    PLATFORM_BULK_SET_OPENING_BALANCES = "platform-bulk-set-opening-balances",
    PLATFORM_LIST_ACCOUNT_GROUPS = "platform-list-account-groups",
    PLATFORM_GET_ACCOUNT_GROUP = "platform-get-account-group",
    PLATFORM_CREATE_ACCOUNT_GROUP = "platform-create-account-group",
    PLATFORM_UPDATE_ACCOUNT_GROUP = "platform-update-account-group",
    PLATFORM_DELETE_ACCOUNT_GROUP = "platform-delete-account-group",
    PLATFORM_LIST_TRANSACTIONS = "platform-list-transactions",
    PLATFORM_GET_TRANSACTION = "platform-get-transaction",
    PLATFORM_UPDATE_TRANSACTION = "platform-update-transaction",
    PLATFORM_LIST_CLASSES = "platform-list-classes",
    PLATFORM_GET_CLASS = "platform-get-class",
    PLATFORM_CREATE_CLASS = "platform-create-class",
    PLATFORM_UPDATE_CLASS = "platform-update-class",
    PLATFORM_DELETE_CLASS = "platform-delete-class",
    PLATFORM_LIST_TRANSACTION_RULES = "platform-list-transaction-rules",
    PLATFORM_GET_TRANSACTION_RULE = "platform-get-transaction-rule",
    PLATFORM_CREATE_TRANSACTION_RULE = "platform-create-transaction-rule",
    PLATFORM_UPDATE_TRANSACTION_RULE = "platform-update-transaction-rule",
    PLATFORM_DELETE_TRANSACTION_RULE = "platform-delete-transaction-rule",
    PLATFORM_CREATE_ACCOUNTING_MIGRATION = "platform-create-accounting-migration",
    PLATFORM_GET_ACCOUNTING_MIGRATION = "platform-get-accounting-migration",
    PLATFORM_GENERATE_MIGRATION_TRANSACTION_RULES = "platform-generate-migration-transaction-rules",
    PLATFORM_LIST_LOCKS = "platform-list-locks",
    PLATFORM_UPDATE_LOCK = "platform-update-lock",
    PLATFORM_LIST_USERS = "platform-list-users",
    PLATFORM_LIST_TASKS = "platform-list-tasks",
    PLATFORM_GET_TASK = "platform-get-task",
    PLATFORM_LIST_TASK_MESSAGES = "platform-list-task-messages",
    PLATFORM_CREATE_TASK_MESSAGE = "platform-create-task-message",
    PLATFORM_LIST_TASK_GROUPS = "platform-list-task-groups",

    MCP = "mcp",
    MCP_OAUTH_REGISTER = "mcp-oauth-register",
    MCP_OAUTH_AUTHORIZE = "mcp-oauth-authorize",
    MCP_OAUTH_TOKEN = "mcp-oauth-token",
    MCP_OAUTH_REVOKE = "mcp-oauth-revoke",

    CLI_SESSION_CREATE = "cli-session-create",
    CLI_SESSION_GET = "cli-session-get",
    CLI_SESSION_APPROVE = "cli-session-approve",
    CLI_SESSION_CANCEL = "cli-session-cancel",
    CLI_SESSION_CLAIM = "cli-session-claim",

    BANK_RECONCILIATION_DELETE = "bank-reconciliation-delete",

    BILLING_ORGANIZATION_ENROLL = "billing-organization-enroll",
    BILLING_TRANSFER_TO_CLIENT = "billing-transfer-to-client",
    BILLING_TRANSFER_REQUEST_FROM_CLIENT = "billing-transfer-request-from-client",
    BILLING_TRANSFER_REQUEST_FROM_ORGANIZATION = "billing-transfer-request-from-organization",
    BILLING_TRANSFER_RESOLVE_REQUEST = "billing-transfer-resolve-request",
    BILLING_TRANSFER_CANCEL_REQUEST = "billing-transfer-cancel-request",
    ORG_BILLING_TRANSFER_REQUEST_INITIATE = "org-billing-transfer-request-initiate",
    ORG_BILLING_TRANSFER_REQUEST_CANCEL = "org-billing-transfer-request-cancel",
    ORG_BILLING_TRANSFER_REQUEST_CHECKOUT = "org-billing-transfer-request-checkout",
    ORG_BILLING_TRANSFER_REQUEST_ACCEPT = "org-billing-transfer-request-accept",
    ORG_BILLING_TRANSFER_REQUEST_PENDING = "org-billing-transfer-request-pending",
    ORG_BILLING_TRANSFER_REQUEST_DECLINE = "org-billing-transfer-request-decline",

    BILL_CREATE_MANUAL = "bill-create-manual",
    BILL_CREATE_MCP = "bill-create-mcp",
    BILL_REPLACE_IMPORTER = "bill-replace-importer",
    BILL_PATCH_IMPORTER = "bill-patch-importer",
    BILL_PATCH_MCP = "bill-patch-mcp",
    BILL_LINE_ITEM_UPDATE = "bill-line-item-update",
    BILL_LINE_ITEM_BULK_UPDATE = "bill-line-item-bulk-update",
    BILL_UPDATE = "bill-update",
    BILL_DOCUMENT_LINK = "bill-document-link",
    BILL_DOCUMENT_UNLINK = "bill-document-unlink",
    BILL_DELETE = "bill-delete",

    CHAT_MESSAGE_SEND = "chat-message-send",
    CHAT_MESSAGE_UPDATE = "chat-message-update",
    CHAT_MESSAGE_DELETE = "chat-message-delete",
    CHAT_MESSAGE_RESOLVE = "chat-message-resolve",
    CHAT_MESSAGE_UNRESOLVE = "chat-message-unresolve",
    CHAT_MESSAGE_REACTION_ADD = "chat-message-reaction-add",
    CHAT_MESSAGE_REACTION_REMOVE = "chat-message-reaction-remove",
    CHAT_SUBTHREAD_CREATE = "chat-subthread-create",
    CHAT_SUBTHREAD_SEND_MESSAGE = "chat-subthread-send-message",
    CHAT_MARK_READ = "chat-mark-read",
    CHAT_MARK_ALL_READ = "chat-mark-all-read",
    CHAT_SET_READ_RECEIPT = "chat-set-read-receipt",

    CHECK_CREATE = "check-create",
    DEPOSIT_CREATE = "deposit-create",
    CASH_ITEM_CREATE_BATCH = "cash-item-create-batch",
    CASH_ITEM_DELETE = "cash-item-delete",

    CLASS_CREATE = "class-create",
    CLASS_UPDATE = "class-update",
    CLASS_DELETE = "class-delete",
    CLASS_CHANGE_POSITION = "class-change-position",

    CATALOG_ITEM_CREATE = "catalog-item-create",
    CATALOG_ITEM_UPDATE = "catalog-item-update",
    CATALOG_ITEM_DELETE = "catalog-item-delete",
    CATALOG_ITEM_DUPLICATE = "catalog-item-duplicate",
    CATALOG_ITEM_BULK_SET_ACTIVE = "catalog-item-bulk-set-active",
    CATALOG_ITEM_ARCHIVE = "catalog-item-archive",
    CATALOG_ITEM_ENABLE = "catalog-item-enable",
    // Price mutations go through CATALOG_ITEM_UPDATE's batched `prices` field
    // (no single-price endpoint exists), so there is no separate
    // CATALOG_ITEM_PRICE_* process name.

    CONSOLIDATION_RELATIONSHIP_CREATE = "consolidation-relationship-create",
    CONSOLIDATION_RELATIONSHIP_UPDATE = "consolidation-relationship-update",
    CONSOLIDATION_RELATIONSHIP_DELETE = "consolidation-relationship-delete",
    CONSOLIDATION_GROUP_CREATE = "consolidation-group-create",
    CONSOLIDATION_GROUP_CONFIG_UPDATE = "consolidation-group-config-update",
    CONSOLIDATION_GROUP_MEMBER_UPDATE = "consolidation-group-member-update",
    CONSOLIDATION_GROUP_DISSOLVE = "consolidation-group-dissolve",
    CONSOLIDATION_ELIMINATING_ENTRY_CREATE = "consolidation-eliminating-entry-create",
    CONSOLIDATION_ELIMINATING_ENTRY_UPDATE = "consolidation-eliminating-entry-update",
    CONSOLIDATION_ELIMINATING_ENTRY_DELETE = "consolidation-eliminating-entry-delete",
    CONSOLIDATION_CANVAS_LAYOUT_UPDATE = "consolidation-canvas-layout-update",
    CONSOLIDATION_CANVAS_LAYOUT_RESET = "consolidation-canvas-layout-reset",

    COA_ACCOUNT_CREATE = "coa-account-create",
    COA_ACCOUNT_UPDATE = "coa-account-update",
    COA_ACCOUNT_DISABLE = "coa-account-disable",
    COA_ACCOUNT_DELETE = "coa-account-delete",
    COA_ACCOUNT_ENABLE = "coa-account-enable",
    COA_ACCOUNT_MERGE = "coa-account-merge",
    COA_ACCOUNT_ROLE_REASSIGN = "coa-account-role-reassign",
    INTEGRATION_COA_MAPPING_UPDATE = "integration-coa-mapping-update",
    CATEGORY_COA_MAPPING_UPDATE = "category-coa-mapping-update",
    COA_ENTITY_ACCOUNT_GROUP_CREATE = "coa-entity-account-group-create",
    COA_ENTITY_ACCOUNT_GROUP_UPDATE = "coa-entity-account-group-update",
    COA_ENTITY_ACCOUNT_GROUP_DELETE = "coa-entity-account-group-delete",

    COA_CHART_EDITOR_ACCOUNT_UPDATE = "coa-chart-editor-account-update",
    COA_CHART_EDITOR_ACCOUNT_ADD = "coa-chart-editor-account-add",
    COA_CHART_EDITOR_GROUP_ADD = "coa-chart-editor-group-add",
    COA_CHART_EDITOR_GROUP_RENAME = "coa-chart-editor-group-rename",
    COA_CHART_EDITOR_DELETE = "coa-chart-editor-delete",
    COA_CHART_EDITOR_ACCOUNT_DISABLED = "coa-chart-editor-account-disabled",
    COA_CHART_EDITOR_ACCOUNT_ENABLED = "coa-chart-editor-account-enabled",
    COA_CHART_EDITOR_MOVE = "coa-chart-editor-move",

    COUNTERPARTY_CREATE = "counterparty-create",
    COUNTERPARTY_UPDATE = "counterparty-update",
    COUNTERPARTY_FIND_SIMILAR = "counterparty-find-similar",
    COPY_GLOBAL_COUNTERPARTY = "copy-global-counterparty",
    DELETE_COUNTERPARTY = "delete-counterparty",
    MERGE_COUNTERPARTIES = "merge-counterparties",

    COUNTERPARTY_CONTACT_CREATE = "counterparty-contact-create",
    COUNTERPARTY_CONTACT_UPDATE = "counterparty-contact-update",
    COUNTERPARTY_CONTACT_DELETE = "counterparty-contact-delete",
    COUNTERPARTY_CONTACT_SET_PRIMARY = "counterparty-contact-set-primary",
    COUNTERPARTY_ADDRESS_CREATE = "counterparty-address-create",
    COUNTERPARTY_ADDRESS_UPDATE = "counterparty-address-update",
    COUNTERPARTY_ADDRESS_DELETE = "counterparty-address-delete",
    COUNTERPARTY_ADDRESS_SET_PRIMARY = "counterparty-address-set-primary",

    CREATE_MANUAL_TRANSACTIONS = "create-manual-transactions",
    UPDATE_MANUAL_TRANSACTION = "update-manual-transaction",

    CREATE_MERCURY_CONNECTION = "create-mercury-connection",
    CREATE_BILLCOM_CONNECTION = "create-billcom-connection",

    ENTITY_CREATE = "entity-create",
    ENTITY_UPDATE = "entity-update",
    ENTITY_UPDATE_BOOKKEEPING_START_DATE = "entity-update-bookkeeping-start-date",
    ENTITY_DELETE = "entity-delete",
    ENTITY_REORDER_ACCOUNTS = "entity-reorder-accounts",
    ENTITY_SAVE_TAX_LOCATIONS = "entity-save-tax-locations",
    ENTITY_UPDATE_ADDRESS = "entity-update-address",
    ENTITY_UPLOAD_LOGO = "entity-upload-logo",
    ENTITY_CREATE_LOGO_UPLOAD_URL = "entity-create-logo-upload-url",

    EXTEND_AI_WEBHOOK_HANDLE = "extend-ai-webhook-handle",

    FILE_SCANNING_PROCESS_COA = "file-scanning-process-coa",
    FILE_SCANNING_EXTRACT_BALANCE_SHEET = "file-scanning-extract-balance-sheet",
    FILE_SCANNING_MAP_ACCOUNTS_TO_COA = "file-scanning-map-accounts-to-coa",
    FILE_SCANNING_MAP_COA_TYPES_CSV = "file-scanning-map-coa-types-csv",

    FINANCIAL_ACCOUNT_DISABLE_ACCOUNT = "financial-account-disable-account",
    FINANCIAL_ACCOUNT_ENABLE_ACCOUNT = "financial-account-enable-account",
    FINANCIAL_ACCOUNT_MERGE_ACCOUNTS = "financial-account-merge-accounts",
    FINANCIAL_ACCOUNT_EXTRACT_MERGED_ACCOUNT = "financial-account-extract-merged-account",
    FINANCIAL_ACCOUNT_CREATE_OPENING_BALANCE = "financial-account-create-opening-balance",
    FINANCIAL_ACCOUNT_UPDATE_OPENING_BALANCE = "financial-account-update-opening-balance",
    FINANCIAL_ACCOUNT_CHANGE_ENTITY = "financial-account-change-entity",
    FINANCIAL_ACCOUNT_CREATE_ACCOUNT = "financial-account-create-account",
    FINANCIAL_ACCOUNT_DELETE = "financial-account-delete",
    FINANCIAL_ACCOUNT_UPDATE = "financial-account-update",
    FINANCIAL_ACCOUNT_UNIMPORT_DOCUMENT = "financial-account-unimport-document",

    FINANCIAL_DOCUMENT_SCAN_DOCUMENT = "financial-document-scan-document",
    FINANCIAL_DOCUMENT_RUN_LOAN_EXTRACTION = "financial-document-run-loan-extraction",
    FINANCIAL_DOCUMENT_UPLOAD_DOCUMENT = "financial-document-upload-document",
    FINANCIAL_DOCUMENT_ADD_TO_IMPORTER = "financial-document-add-to-importer",
    FINANCIAL_DOCUMENT_PROCESS_ARCHIVE = "financial-document-process-archive",
    FINANCIAL_DOCUMENT_DETACH_FINANCIAL_TRANSACTION = "financial-document-detach-financial-transaction",
    FINANCIAL_DOCUMENT_CHANGE_ENTITY = "financial-document-change-entity",
    FINANCIAL_DOCUMENT_DELETE_DOCUMENT = "financial-document-delete-document",
    FINANCIAL_DOCUMENT_BULK_ACTION = "financial-document-bulk-action",
    FINANCIAL_DOCUMENT_EXTRACT_ACCOUNT_INFO = "financial-document-extract-account-info",
    FINANCIAL_DOCUMENT_UPDATE_DOCUMENT_METADATA = "financial-document-update-document-metadata",
    FINANCIAL_DOCUMENT_UPDATE_TAXONOMY_EXTRACTION = "financial-document-update-taxonomy-extraction",
    FINANCIAL_DOCUMENT_UPDATE_BALANCE_SHEET_DETAILS = "financial-document-update-balance-sheet-details",
    FINANCIAL_DOCUMENT_BATCH_UPDATE_BALANCE_SHEET_ROWS = "financial-document-batch-update-balance-sheet-rows",
    FINANCIAL_DOCUMENT_UPDATE_INVOICE_EXTRACTIONS = "financial-document-update-invoice-extractions",
    FINANCIAL_DOCUMENT_UPDATE_BILL_EXTRACTIONS = "financial-document-update-bill-extractions",
    FINANCIAL_DOCUMENT_UPDATE_INVOICE_EXTRACTION_DETAILS = "financial-document-update-invoice-extraction-details",
    FINANCIAL_DOCUMENT_BATCH_UPDATE_INVOICE_EXTRACTION_ROWS = "financial-document-batch-update-invoice-extraction-rows",
    FINANCIAL_DOCUMENT_UPDATE_BILL_EXTRACTION_DETAILS = "financial-document-update-bill-extraction-details",
    FINANCIAL_DOCUMENT_BATCH_UPDATE_BILL_EXTRACTION_ROWS = "financial-document-batch-update-bill-extraction-rows",
    FINANCIAL_DOCUMENT_REMOVE_IMPORTER_ERROR = "financial-document-remove-importer-error",
    FINANCIAL_DOCUMENT_FINALIZE_TRANSACTIONS_IMPORT = "financial-document-finalize-transactions-import",
    FINANCIAL_DOCUMENT_FINALIZE_INVOICES_IMPORT = "financial-document-finalize-invoices-import",
    FINANCIAL_DOCUMENT_FINALIZE_BILLS_IMPORT = "financial-document-finalize-bills-import",
    FINANCIAL_DOCUMENT_CONFIRM_ACCRUAL_COUNTERPARTIES = "financial-document-confirm-accrual-counterparties",
    FINANCIAL_DOCUMENT_CHECK_FOR_IMPORTER_ERRORS = "financial-document-check-for-importer-errors",
    FINANCIAL_DOCUMENT_REMOVE_FROM_IMPORTER = "financial-document-remove-from-importer",
    FINANCIAL_DOCUMENT_CREATE_LINK = "financial-document-create-link",
    FINANCIAL_DOCUMENT_RUN_TAXONOMY_EXTRACTION = "financial-document-run-taxonomy-extraction",
    FINANCIAL_DOCUMENT_UPDATE_DOCUMENT_CATEGORY = "financial-document-update-document-category",
    FINANCIAL_DOCUMENT_UPDATE_COUNTERPARTY = "financial-document-update-counterparty",
    FINANCIAL_DOCUMENT_UPDATE_ACCOUNT_INFO = "financial-document-update-account-info",
    FINANCIAL_DOCUMENT_DOWNLOAD_DOCUMENTS = "financial-document-download-documents",
    FINANCIAL_DOCUMENT_DOWNLOAD_FILE = "financial-document-download-file",
    FINANCIAL_DOCUMENT_CREATE_UPLOAD_URL = "financial-document-create-upload-url",
    FINANCIAL_DOCUMENT_MCP_REQUEST_UPLOAD_URL = "financial-document-mcp-request-upload-url",
    FINANCIAL_DOCUMENT_MCP_CONFIRM_UPLOAD = "financial-document-mcp-confirm-upload",
    FINANCIAL_DOCUMENT_MCP_DOWNLOAD = "financial-document-mcp-download",
    EXPORT_SAVE_DOCUMENT = "export-save-document",

    INTEGRATION_CONNECTION_FIX = "integration-connection-fix",
    INTEGRATION_CONNECTION_REMOVE = "integration-connection-remove",

    INVITE_MEMBER = "invite-member",
    REMOVE_MEMBER = "remove-member",
    REMOVE_ORGANIZATION_MEMBERS = "remove-organization-members",
    UPDATE_WORKSPACE_ASSIGNMENT = "update-workspace-assignment",
    RESEND_INVITE = "resend-invite",
    CANCEL_INVITE = "cancel-invite",
    TRANSFER_PRIMARY_ADMIN = "transfer-primary-admin",
    TRANSFER_ORGANIZATION_OWNER = "transfer-organization-owner",

    INVOICE_CREATE_MANUAL = "invoice-create-manual",
    INVOICE_CREATE_MCP = "invoice-create-mcp",
    INVOICE_CREATE_NATIVE = "invoice-create-native",
    INVOICE_CREATE_NATIVE_LOGO_UPLOAD_URL = "invoice-create-native-logo-upload-url",
    INVOICE_SEND_NATIVE = "invoice-send-native",
    INVOICE_RESEND_NATIVE = "invoice-resend-native",
    INVOICE_TEST_SEND_NATIVE = "invoice-test-send-native",
    INVOICE_SCHEDULE_NATIVE = "invoice-schedule-native",
    INVOICE_DUPLICATE_NATIVE = "invoice-duplicate-native",
    INVOICE_REPLACE_IMPORTER = "invoice-replace-importer",
    INVOICE_PATCH_IMPORTER = "invoice-patch-importer",
    INVOICE_PATCH_MCP = "invoice-patch-mcp",
    INVOICE_LINE_ITEM_UPDATE = "invoice-line-item-update",
    INVOICE_LINE_ITEM_BULK_UPDATE = "invoice-line-item-bulk-update",
    INVOICE_UPDATE = "invoice-update",
    INVOICE_BULK_PDF_DOWNLOAD = "invoice-bulk-pdf-download",
    INVOICE_DOCUMENT_LINK = "invoice-document-link",
    INVOICE_DOCUMENT_UNLINK = "invoice-document-unlink",
    INVOICE_DELETE = "invoice-delete",
    INVOICE_TEMPLATE_CREATE = "invoice-template-create",
    INVOICE_TEMPLATE_CREATE_FROM_INVOICE = "invoice-template-create-from-invoice",
    INVOICE_TEMPLATE_RENAME = "invoice-template-rename",
    INVOICE_TEMPLATE_ARCHIVE = "invoice-template-archive",
    INVOICE_TEMPLATE_UNARCHIVE = "invoice-template-unarchive",
    INVOICE_TEMPLATE_DELETE = "invoice-template-delete",
    INVOICE_TEMPLATE_UPDATE_CONTENT = "invoice-template-update-content",

    LEDGER_CREATE_FOR_ENTITY = "ledger-create-for-entity",
    LEDGER_UPDATE = "ledger-update",
    LEDGER_SET_STATUS = "ledger-set-status",
    LEDGER_DUPLICATE = "ledger-duplicate",

    LOCK_UPDATE = "lock-update",

    LOG_STREAM_WEBHOOK_HANDLE = "log-stream-webhook-handle",

    ORGANIZATION_CREATE = "organization-create",
    ORGANIZATION_CREATE_ONBOARDING = "organization-create-onboarding",
    ORGANIZATION_UPDATE = "organization-update",
    ORGANIZATION_UPDATE_PROFILE = "organization-update-profile",
    ORGANIZATION_CREATE_CLIENT = "organization-create-client",
    ORGANIZATION_CREATE_FIRM_WORKSPACE = "organization-create-firm-workspace",
    ORGANIZATION_GET_DEMO_WORKSPACE = "organization-get-demo-workspace",
    ORGANIZATION_UPDATE_CLIENT_ENTITY = "organization-update-client-entity",
    ORGANIZATION_UPDATE_CLIENT = "organization-update-client",
    ORGANIZATION_PATCH_CLIENT = "organization-patch-client",
    ORGANIZATION_DELETE_CLIENT = "organization-delete-client",
    ORGANIZATION_REMOVE_CLIENT = "organization-remove-client",
    ORGANIZATION_RECORD_CLIENT_ACCESS = "organization-record-client-access",
    ORGANIZATION_LIST_CLIENT_ACCESS = "organization-list-client-access",
    ORGANIZATION_REMOVE_ENTITY = "organization-remove-entity",
    ORGANIZATION_TRANSFER_BILLING_AND_REMOVE_CLIENT = "organization-transfer-billing-and-remove-client",
    ORGANIZATION_UPSERT_BILLING = "organization-upsert-billing",
    ORGANIZATION_ADMIN_LINK_STRIPE_CUSTOMER = "organization-admin-link-stripe-customer",
    ORGANIZATION_ADMIN_SETUP_V3_SUBSCRIPTION = "organization-admin-setup-v3-subscription",
    ORGANIZATION_ADMIN_ENROLL_AIP = "organization-admin-enroll-aip",
    ORGANIZATION_ADMIN_UNMARK_AIP = "organization-admin-unmark-aip",
    ORGANIZATION_ADMIN_DELETE_ORGANIZATION = "organization-admin-delete-organization",
    ORGANIZATION_ADMIN_CANCEL_SUBSCRIPTION = "organization-admin-cancel-subscription",
    ORGANIZATION_ADMIN_UPDATE_ALLOWED_PLANS = "organization-admin-update-allowed-plans",
    ORGANIZATION_ADMIN_UPDATE_BILLING_TRANSFER_DISCOUNT_CODE = "organization-admin-update-billing-transfer-discount-code",
    ORGANIZATION_ADMIN_CREATE_DEMO_WORKSPACE = "organization-admin-create-demo-workspace",
    ORGANIZATION_ADMIN_DROP_SUBSCRIPTION_LINK = "organization-admin-drop-subscription-link",
    ORGANIZATION_ADMIN_MOVE_TO_V3_CATALOG = "organization-admin-move-to-v3-catalog",
    ORGANIZATION_ADMIN_RETRIGGER_BILLING_REPORT = "organization-admin-retrigger-billing-report",
    SUPPORT_ADMIN_CREATE_POD = "support-admin-create-pod",
    SUPPORT_ADMIN_UPDATE_POD = "support-admin-update-pod",
    SUPPORT_ADMIN_DEACTIVATE_POD = "support-admin-deactivate-pod",
    SUPPORT_ADMIN_ADD_POD_MEMBER = "support-admin-add-pod-member",
    SUPPORT_ADMIN_UPDATE_POD_MEMBER = "support-admin-update-pod-member",
    SUPPORT_ADMIN_REMOVE_POD_MEMBER = "support-admin-remove-pod-member",
    SUPPORT_ADMIN_ASSIGN_ORGANIZATION_POD = "support-admin-assign-organization-pod",
    SUPPORT_ADMIN_BULK_ASSIGN_ORGANIZATION_POD = "support-admin-bulk-assign-organization-pod",
    SUPPORT_ADMIN_SET_SUPPORT_TIER_OVERRIDE = "support-admin-set-support-tier-override",
    SUPPORT_ADMIN_SET_SUPPORT_NOTES = "support-admin-set-support-notes",
    SUPPORT_ADMIN_SET_SLACK_CHANNEL = "support-admin-set-slack-channel",
    SUPPORT_ADMIN_UNBLOCK_EMAIL_SENDING = "support-admin-unblock-email-sending",
    SUPPORT_MCP_CREDENTIAL_CREATE = "support-mcp-credential-create",
    SUPPORT_MCP_CREDENTIAL_ROTATE = "support-mcp-credential-rotate",
    SUPPORT_MCP_CREDENTIAL_REISSUE = "support-mcp-credential-reissue",
    SUPPORT_MCP_CREDENTIAL_CONFIRM = "support-mcp-credential-confirm",
    SUPPORT_MCP_CREDENTIAL_REVOKE = "support-mcp-credential-revoke",
    SUPPORT_MCP = "support-mcp",
    ORGANIZATION_UPLOAD_LOGO = "organization-upload-logo",
    ORGANIZATION_REMOVE_UNONBOARDED = "organization-remove-unonboarded",
    ORGANIZATION_SERVICE_CREATE = "organization-service-create",
    ORGANIZATION_SERVICE_UPDATE = "organization-service-update",
    ORGANIZATION_SERVICE_DELETE = "organization-service-delete",
    ORGANIZATION_INTEGRATION_ASSIGN_ACCOUNTS_BATCH = "organization-integration-assign-accounts-batch",
    ORGANIZATION_INTEGRATION_REMIND_CONNECTIONS = "organization-integration-remind-connections",

    SERVICE_TEMPLATE_SCHEDULE_CREATE = "service-template-schedule-create",
    SERVICE_TEMPLATE_SCHEDULE_UPDATE = "service-template-schedule-update",
    SERVICE_TEMPLATE_SCHEDULE_DELETE = "service-template-schedule-delete",
    SERVICE_TEMPLATE_SCHEDULE_BULK_ACTION = "svc-tmpl-schedule-bulk-action",
    SERVICE_TEMPLATE_RECURRENCE_OCCURRENCE_SKIP = "svc-tmpl-rec-occ-skip",
    SERVICE_TEMPLATE_RECURRENCE_OCCURRENCE_UNSKIP = "svc-tmpl-rec-occ-unskip",
    SERVICE_TEMPLATE_RECURRENCE_OCCURRENCE_APPLY = "svc-tmpl-rec-occ-apply",
    SERVICE_TEMPLATE_RECURRENCE_OCCURRENCE_ROLE = "svc-tmpl-rec-occ-role",
    SERVICE_TEMPLATE_RECURRENCE_OCCURRENCE_BULK_ACTION = "svc-tmpl-rec-occ-bulk-action",
    SERVICE_TEMPLATE_RECURRENCE_OCCURRENCE_BULK_ROLE = "svc-tmpl-rec-occ-bulk-role",

    ORGANIZATION_CLOSE_STAGE_CREATE = "organization-close-stage-create",
    ORGANIZATION_CLOSE_STAGE_UPDATE = "organization-close-stage-update",
    ORGANIZATION_CLOSE_STAGE_DELETE = "organization-close-stage-delete",
    ORGANIZATION_CLOSE_STAGE_CHANGE_POSITION = "organization-close-stage-change-position",

    ORGANIZATION_TASK_TEMPLATE_CREATE = "organization-task-template-create",
    ORGANIZATION_TASK_TEMPLATE_UPDATE = "organization-task-template-update",
    ORGANIZATION_TASK_TEMPLATE_ARCHIVE = "organization-task-template-archive",
    ORGANIZATION_TASK_TEMPLATE_UNARCHIVE = "organization-task-template-unarchive",
    ORGANIZATION_TASK_TEMPLATE_DELETE = "organization-task-template-delete",
    ORGANIZATION_TASK_TEMPLATE_DETACH = "organization-task-template-detach",
    ORGANIZATION_TASK_TEMPLATE_BULK_ARCHIVE = "organization-task-template-bulk-archive",
    ORGANIZATION_TASK_TEMPLATE_BULK_UNARCHIVE = "organization-task-template-bulk-unarchive",
    ORGANIZATION_TASK_TEMPLATE_BULK_DELETE = "organization-task-template-bulk-delete",
    ORGANIZATION_TASK_TEMPLATE_BULK_DETACH = "organization-task-template-bulk-detach",

    PAYPAL_MIGRATE_FROM_PLAID = "paypal-migrate-from-plaid",
    PAYPAL_CREATE_CONNECTION = "paypal-create-connection",

    PLAID_WEBHOOK = "plaid-webhook",
    PLAID_WEBHOOK_ERROR = "plaid-webhook-error",
    PLAID_WEBHOOK_DEFAULT_UPDATE = "plaid-webhook-default-update",
    PLAID_WEBHOOK_HISTORICAL_UPDATE = "plaid-webhook-historical-update",
    PLAID_WEBHOOK_LOGIN_REPAIRED = "plaid-webhook-login-repaired",
    PLAID_WEBHOOK_TRANSACTIONS_REMOVED = "plaid-webhook-transactions-removed",
    PLAID_WEBHOOK_NEW_ACCOUNTS_AVAILABLE = "plaid-webhook-new-accounts-available",
    PLAID_CONNECTION_ADDED = "plaid-connection-added",
    PLAID_CONNECTION_ADD_NEW_ACCOUNTS = "plaid-connection-add-new-accounts",
    PLAID_CONNECTION_DELETED = "plaid-connection-deleted",
    PLAID_WEBHOOK_SYNC_UPDATES_AVAILABLE = "plaid-webhook-sync-updates-available",
    PLAID_WEBHOOK_STATEMENTS_REFRESH_COMPLETE = "plaid-webhook-statements-refresh-complete",
    PLAID_CONNECTION_RELINK_SUCCESS = "plaid-connection-relink-success",

    PLAIN_WEBHOOK_HANDLE = "plain-webhook-handle",

    QUICKBOOKS_CREATE_CONNECTION = "quickbooks-create-connection",

    RAMP_CONNECTION_CREATE = "ramp-connection-create",
    RAMP_CONNECTION_FIX = "ramp-connection-fix",

    RECEIPTS_WEBHOOK_HANDLE = "receipts-webhook-handle",
    RECEIPTS_ADD_PHONE_NUMBER = "receipts-add-phone-number",
    RECEIPTS_REMOVE = "receipts-remove",
    RECEIPTS_ADD_EMAIL_ADDRESS = "receipts-add-email-address",

    RECONCILE_GUSTO_TRANSFERS = "reconcile-gusto-transfers",
    RECONCILE_LOAN = "reconcile-loan",
    RECONCILE_TRANSACTIONS = "reconcile-transactions",

    REMOVE_INTEGRATION_ACCOUNT = "remove-integration-account",

    RULE_CREATE = "rule-create",
    RULE_UPDATE = "rule-update",
    RULE_DELETE = "rule-delete",
    RULE_NOTE_UPDATE = "rule-note-update",
    RULE_REVIEW_ADD = "rule-review-add",
    RULE_REVIEW_REVOKE = "rule-review-revoke",
    RULE_REVIEWS_GET = "rule-reviews-get",
    RULE_GET_MATCHING_TRANSACTIONS = "rule-get-matching-transactions",
    RULE_GET_MATCHING_TRANSFER_TRANSACTIONS = "rule-get-matching-transfer-transactions",
    RULE_GET_APPLIED_TRANSACTIONS = "rule-get-applied-transactions",
    RULE_GET_APPLIED_TRANSFER_TRANSACTIONS = "rule-get-applied-transfer-transactions",
    RULE_GROUP_CREATE = "rule-group-create",
    RULE_GROUP_UPDATE = "rule-group-update",
    RULE_GROUP_DELETE = "rule-group-delete",

    SIMULATIONS_AUTH_HANDLE_SMS_GATEWAY = "simulations-auth-handle-sms-gateway",
    SIMULATIONS_SIMULATE_INCOMING_SMS = "simulations-simulate-incoming-sms",
    SIMULATIONS_REVOKE_PERMISSIONS = "simulations-revoke-permissions",
    SIMULATIONS_SIMULATE_PLAID_ERROR = "simulations-simulate-plaid-error",

    SMS_WEBHOOK_HANDLE = "sms-webhook-handle",

    SPREADSHEET_UPDATE = "spreadsheet-update",

    STRIPE_WEBHOOK_HANDLE = "stripe-webhook-handle",
    STRIPE_CONNECT_WEBHOOK_HANDLE = "stripe-connect-webhook-handle",
    CREATE_STRIPE_CONNECTION = "create-stripe-connection",
    CREATE_ADP_RUN_CONNECTION = "create-adp-run-connection",
    FIX_STRIPE_CONNECTION = "fix-stripe-connection",
    CREATE_STRIPE_EXPRESS_CONNECTION = "create-stripe-express-connection",
    REMINT_STRIPE_EXPRESS_ACCOUNT_LINK = "remint-stripe-express-account-link",
    REFRESH_STRIPE_EXPRESS_CACHE = "refresh-stripe-express-cache",
    START_OVER_STRIPE_EXPRESS_CONNECTION = "start-over-stripe-express-connection",
    CREATE_STRIPE_EXPRESS_LOGIN_LINK = "create-stripe-express-login-link",
    GET_STRIPE_EXPRESS_BRANDING = "get-stripe-express-branding",
    UPDATE_STRIPE_EXPRESS_BRANDING = "update-stripe-express-branding",
    UPDATE_STRIPE_INVOICE_JOURNAL_ENTRY_MODE = "update-stripe-invoice-journal-entry-mode",

    CREATE_GUSTO_CONNECTION = "create-gusto-connection",
    CREATE_GUSTO_ACCOUNT = "create-gusto-account",
    SYNC_GUSTO_CONNECTION = "sync-gusto-connection",
    FIX_GUSTO_CONNECTION = "fix-gusto-connection",

    TASK_CREATE = "task-create",
    TASK_DELETE = "task-delete",
    TASK_UPDATE = "task-update",
    TASK_DOCUMENT_LINK = "task-document-link",
    TASK_DOCUMENT_UNLINK = "task-document-unlink",
    TASK_BULK_UPDATE = "task-bulk-update",
    TASK_GROUP_CREATE = "task-group-create",
    TASK_GROUP_UPDATE = "task-group-update",
    TASK_STICKY_REFRESH = "task-sticky-refresh",
    TASK_GROUP_DELETE = "task-group-delete",

    TASK_TEMPLATE_CREATE = "task-template-create",
    TASK_TEMPLATE_UPDATE = "task-template-update",
    TASK_TEMPLATE_DELETE = "task-template-delete",
    TASK_TEMPLATE_BULK_SAVE = "task-template-bulk-save",
    TASK_TEMPLATE_PREVIEW = "task-template-preview",

    CANCEL_CLOSE = "cancel-close",
    DELETE_CLOSE = "delete-close",
    UPDATE_CLOSE = "update-close",

    CLOSE_TEMPLATE_CREATE = "close-template-create",
    CLOSE_TEMPLATE_UPDATE = "close-template-update",
    CLOSE_TEMPLATE_DELETE = "close-template-delete",
    CLOSE_TEMPLATE_APPLY = "close-template-apply",
    CLOSE_TEMPLATE_PREVIEW = "close-template-preview",
    CLOSE_TEMPLATE_RESOLVE_TASK_VIEW = "close-template-resolve-task-view",
    CLOSE_TEMPLATE_DUPLICATE = "close-template-duplicate",
    CLOSE_TEMPLATE_ARCHIVE = "close-template-archive",
    CLOSE_TEMPLATE_UNARCHIVE = "close-template-unarchive",

    CHART_OF_ACCOUNTS_TEMPLATE_CREATE = "chart-of-accounts-template-create",
    CHART_OF_ACCOUNTS_TEMPLATE_UPDATE = "chart-of-accounts-template-update",
    CHART_OF_ACCOUNTS_TEMPLATE_DELETE = "chart-of-accounts-template-delete",
    CHART_OF_ACCOUNTS_TEMPLATE_ARCHIVE = "chart-of-accounts-template-archive",
    CHART_OF_ACCOUNTS_TEMPLATE_UNARCHIVE = "chart-of-accounts-template-unarchive",
    CHART_OF_ACCOUNTS_TEMPLATE_ACCOUNTS_SAVE = "chart-of-accounts-template-accounts-save",
    CHART_OF_ACCOUNTS_TEMPLATE_PREVIEW = "chart-of-accounts-template-preview",
    CHART_OF_ACCOUNTS_TEMPLATE_APPLY = "chart-of-accounts-template-apply",
    CHART_OF_ACCOUNTS_TEMPLATE_APPLY_UNDO = "chart-of-accounts-template-apply-undo",

    SCHEDULE_TEMPLATE_CREATE = "schedule-template-create",
    SCHEDULE_TEMPLATE_UPDATE = "schedule-template-update",
    SCHEDULE_TEMPLATE_APPLY = "schedule-template-apply",
    SCHEDULE_TEMPLATE_APPLY_BULK = "schedule-template-apply-bulk",
    SCHEDULE_APPLICATIONS_UNAPPLY = "schedule-applications-unapply",
    SCHEDULE_APPLICATION_DELETE = "schedule-application-delete",
    SCHEDULE_APPLICATIONS_DELETE_BULK = "schedule-applications-delete-bulk",
    SCHEDULE_APPLICATION_CANCEL = "schedule-application-cancel",
    SCHEDULE_APPLICATION_PAUSE = "schedule-application-pause",
    SCHEDULE_APPLICATION_RESUME = "schedule-application-resume",
    SCHEDULE_APPLICATION_CHANGE = "schedule-application-change",
    SCHEDULE_APPLICATIONS_LIFECYCLE_BULK = "schedule-applications-lifecycle-bulk",
    SCHEDULE_APPLICATION_MARK_BILLED = "schedule-application-mark-billed",
    SCHEDULE_APPLICATION_MARK_UNBILLED = "schedule-application-mark-unbilled",
    SCHEDULE_APPLICATION_MARK_BILLED_BULK = "schedule-application-mark-billed-bulk",
    SCHEDULE_TEMPLATE_ARCHIVE = "schedule-template-archive",
    SCHEDULE_TEMPLATE_RESTORE = "schedule-template-restore",
    SCHEDULE_TEMPLATE_DELETE = "schedule-template-delete",
    SCHEDULE_MILESTONE_RECOGNIZE = "schedule-milestone-recognize",
    SCHEDULE_MILESTONE_RECOGNIZE_BULK = "schedule-milestone-recognize-bulk",
    SCHEDULE_REVIEW_CONFIRM_RECOGNITION = "schedule-review-confirm-recognition",
    SCHEDULE_REVIEW_CONFIRM_ALL_RECOGNITION = "schedule-review-confirm-all-recognition",
    SCHEDULE_REVIEW_DISMISS_SUSPICIOUS = "schedule-review-dismiss-suspicious",
    SCHEDULE_REVIEW_RESTORE_SUSPICIOUS = "schedule-review-restore-suspicious",
    SCHEDULE_REVIEW_CONFIRM_DRAFTS = "schedule-review-confirm-drafts",
    SCHEDULE_REVIEW_DISMISS_DRAFTS = "schedule-review-dismiss-drafts",
    SCHEDULE_REVIEW_RESTORE_DRAFTS = "schedule-review-restore-drafts",

    TRACKING_TRACK_EVENT = "tracking-track-event",

    TRANSACTION_UPDATE = "transaction-update",
    TRANSACTION_BULK_UPDATE = "transaction-bulk-update",
    TRANSACTION_QUERY_SNAPSHOT = "transaction-query-snapshot",
    TRANSACTION_MATCH_TRANSFER = "transaction-match-transfer",
    TRANSACTION_UNMATCH_TRANSFER = "transaction-unmatch-transfer",
    TRANSACTION_SPLIT_V2_UPDATE = "transaction-split-v2-update",
    TRANSACTION_BULK_UNSPLIT = "transaction-bulk-unsplit",
    TRANSACTION_CREATE_LINK = "transaction-create-link",
    TRANSACTION_UPLOAD_RECEIPT = "transaction-upload-receipt",
    TRANSACTION_DETACH_FINANCIAL_DOCUMENT = "transaction-detach-financial-document",
    TRANSACTION_BULK_MARK_FOR_DELETION = "transaction-bulk-mark-for-deletion",
    TRANSACTION_MARK_FOR_DELETION = "transaction-mark-for-deletion",
    TRANSACTION_CANCEL_DELETION = "transaction-cancel-deletion",
    TRANSACTION_FINALIZE_DELETION = "transaction-finalize-deletion",
    TRANSACTION_MATCH_FOR_WORKSPACE = "transaction-match-for-workspace",

    ACCRUAL_REVIEW_BULK_APPROVE = "accrual-review-bulk-approve",

    UPDATE_CATEGORY = "update-category",
    CREATE_CATEGORY = "create-category",
    DELETE_CATEGORY = "delete-category",

    UPDATE_DOCUMENT_CATEGORY = "update-document-category",
    CREATE_DOCUMENT_CATEGORY = "create-document-category",
    DELETE_DOCUMENT_CATEGORY = "delete-document-category",

    USER_CREATE_AVATAR_UPLOAD_URL = "user-create-avatar-upload-url",
    USER_UPLOAD_AVATAR = "user-upload-avatar",
    USER_ONBOARDING_REGISTER = "user-onboarding-register",
    USER_ONBOARDING_GOOGLE_AUTH = "user-onboarding-google-auth",
    USER_UPDATE = "user-update",
    USER_UPDATE_META = "user-update-meta",
    USER_SET_PRODUCT_TIP = "user-set-product-tip",
    USER_CLEAR_INITIAL_PRODUCT_TIPS = "user-clear-initial-product-tips",
    USER_UPDATE_PROFILE = "user-update-profile",
    USER_ADD_PHONE_NUMBER = "user-add-phone-number",
    USER_ADMIN_SUSPEND_USER = "user-admin-suspend-user",
    USER_ADMIN_COMPLETE_ORGANIZATION_ONBOARDING = "user-admin-complete-organization-onboarding",
    USER_ADMIN_ASSIGN_SUPPORT_USER = "user-admin-assign-support-user",
    USER_ADMIN_ASSIGN_SUPPORT_ORGANIZATION = "user-admin-assign-support-organization",
    USER_ONBOARDING_COMPLETE_WORKSPACE = "user-onboarding-complete-workspace",
    USER_ONBOARDING_COMPLETE_INVITE = "user-onboarding-complete-invite",
    USER_REGISTER_VALIDATE_INVITE_CODE = "user-register-validate-invite-code",
    USER_VERIFICATION_REQUEST_IDENTITY = "user-verification-request-identity",
    COMPLETE_ORGANIZATION_ONBOARDING = "complete-organization-onboarding",

    VIEW_CREATE = "view-create",
    VIEW_UPDATE = "view-update",
    VIEW_DELETE = "view-delete",

    IMPORTED_ACCOUNT_BULK_UPDATE = "imported-account-bulk-update",

    UPDATE_WORKSPACE_PREFERENCES = "update-workspace-preferences",
    ACCOUNTING_INTEGRATION_FINALIZE_MAPPING = "accounting-integration-finalize-mapping",
    ACCOUNTING_INTEGRATION_FINALIZE_MIGRATED_DATA_MAPPING = "accounting-integration-finalize-migrated-data-mapping",
    ACCOUNTING_MIGRATION_CREATE = "accounting-migration-create",
    ACCOUNTING_MIGRATION_UPDATE_START_DATE = "accounting-migration-update-start-date",
    ACCOUNTING_MIGRATION_UPDATE_END_DATE = "accounting-migration-update-end-date",
    ACCOUNTING_MIGRATION_REMOVE = "accounting-migration-remove",
    ACCOUNTING_MIGRATION_REFRESH = "accounting-migration-refresh",
    ACCOUNTING_MIGRATION_IMPORTED_ACCOUNTS_FROM_BALANCE_SHEET = "accounting-migration-imported-accounts-from-balance-sheet",
    ACCOUNTING_MIGRATION_IMPORTED_ACCOUNTS_FROM_COA = "accounting-migration-imported-accounts-from-coa",
    ACCOUNTING_DOCUMENT_MIGRATION_UPLOAD = "accounting-document-migration-upload",
    ACCOUNTING_DOCUMENT_MIGRATION_VALIDATE = "accounting-document-migration-validate",
    ACCOUNTING_DOCUMENT_MIGRATION_UPLOAD_JSON = "accounting-document-migration-upload-json",
    ACCOUNTING_DOCUMENT_MIGRATION_EXTRACT = "accounting-document-migration-extract",
    ACCOUNTING_DOCUMENT_MIGRATION_SET_GL_BASIS = "accounting-document-migration-set-gl-basis",
    ACCOUNTING_DOCUMENT_MIGRATION_SET_QBD_UPLOAD_SOURCE = "accounting-document-migration-set-qbd-upload-source",

    AUDIT_LOG_REVERT = "audit-log-revert",

    DEMO_USER_REMOVE = "demo-user-remove",
    DEMO_USER_CREATE = "demo-user-create",
    DEMO_USER_UPDATE = "demo-user-update",

    FLAT_RATE_BILLING_PREPARE_CHECKOUT = "flat-rate-billing-prepare-checkout",
    FLAT_RATE_BILLING_START_ENTERPRISE_TRIAL = "flat-rate-billing-start-enterprise-trial",
    FLAT_RATE_BILLING_CALCULATE_PRICE = "flat-rate-billing-calculate-price",
    FLAT_RATE_BILLING_SUBSCRIBE = "flat-rate-billing-subscribe",
    FLAT_RATE_BILLING_UPGRADE = "flat-rate-billing-upgrade",
    FLAT_RATE_BILLING_CONVERT = "flat-rate-billing-convert",
    FLAT_RATE_BILLING_DOWNGRADE = "flat-rate-billing-downgrade",
    FLAT_RATE_BILLING_UPGRADE_TO_CATALOG_V2 = "flat-rate-billing-upgrade-to-catalog-v2",
    FLAT_RATE_BILLING_UPGRADE_TO_CATALOG_V3 = "flat-rate-billing-upgrade-to-catalog-v3",
    WORKSPACE_CHECK_ORGANIZATION_INVITES = "workspace-check-organization-invites",
    WORKSPACE_EMAIL_ALIAS_CREATE = "workspace-email-alias-create",
    WORKSPACE_EMAIL_ALIAS_REMOVE = "workspace-email-alias-remove",
    PLAIN_SUPPORT_CHAT_START = "plain-support-chat-start",
    PLAIN_SUPPORT_CHAT_SEND = "plain-support-chat-send",
    PLAIN_SUPPORT_CHAT_ATTACHMENT_UPLOAD = "plain-support-chat-attachment-upload",
    PLAIN_SUPPORT_CHAT_HANDOFF = "plain-support-chat-handoff",
    PLAIN_SUPPORT_CHAT_HANDOFF_DRAFT = "plain-support-chat-handoff-draft",
    PLAIN_SUPPORT_CHAT_CONTEXT_SCRIPT = "plain-support-chat-context-script",
    PLAIN_SUPPORT_CHAT_RESOLVE = "plain-support-chat-resolve",
    PLAIN_SUPPORT_LIFECYCLE_WORKFLOW_CALLBACK = "plain-support-lifecycle-workflow-callback",
    AGENT_CHAT_SEND_MESSAGE = "agent-chat-send-message",
    AGENT_CHAT_SEND_MESSAGE_STREAM = "agent-chat-send-message-stream",
    PLAIN_SUPPORT_CHAT_EVENTS = "plain-support-chat-events",
    TRANSACTION_FIELD_REVIEW_ADD = "transaction-field-review-add",
    TRANSACTION_FIELD_REVIEW_REVOKE = "transaction-field-review-revoke",
    TRANSACTION_FIELD_REVIEW_BULK_ADD = "transaction-field-review-bulk-add",
    TRANSACTION_FIELD_REVIEW_BULK_REVOKE = "transaction-field-review-bulk-revoke",
    COUNTERPARTY_FIELD_REVIEW_ADD = "counterparty-field-review-add",
    COUNTERPARTY_FIELD_REVIEW_REVOKE = "counterparty-field-review-revoke",
    COUNTERPARTY_TIN_GRANT = "counterparty-tin-grant",
    COUNTERPARTY_TIN_CLEAR = "counterparty-tin-clear",
    COUNTERPARTY_TIN_WRITE = "counterparty-tin-write",
    COUNTERPARTY_TIN_REVEAL = "counterparty-tin-reveal",
    COUNTERPARTY_TIN_EXPORT_GRANT = "counterparty-tin-export-grant",
    COUNTERPARTY_TIN_EXPORT = "counterparty-tin-export",
    REPORT_SETTINGS_UPDATE = "report-settings-update",
    FEATURE_FLAG_OVERRIDE_SET = "feature-flag-override-set",
    FEATURE_FLAG_OVERRIDE_DELETE = "feature-flag-override-delete",
    FEATURE_FLAG_OVERRIDE_DELETE_ALL = "feature-flag-override-delete-all",
    ORGANIZATION_FEATURE_FLAG_OVERRIDE_SET = "organization-feature-flag-override-set",
    ORGANIZATION_FEATURE_FLAG_OVERRIDE_DELETE = "organization-feature-flag-override-delete",
    ORGANIZATION_FEATURE_FLAG_OVERRIDE_DELETE_ALL = "organization-feature-flag-override-delete-all",
    REPORT_SETTINGS_TEMPLATE_CREATE = "report-settings-template-create",
    REPORT_SETTINGS_TEMPLATE_UPDATE = "report-settings-template-update",
    REPORT_SETTINGS_TEMPLATE_SETTINGS_UPDATE = "report-settings-template-settings-update",
    REPORT_SETTINGS_TEMPLATE_ARCHIVE = "report-settings-template-archive",
    REPORT_SETTINGS_TEMPLATE_UNARCHIVE = "report-settings-template-unarchive",
    REPORT_SETTINGS_TEMPLATE_DELETE = "report-settings-template-delete",
    REPORT_SETTINGS_TEMPLATE_SET_DEFAULT = "report-settings-template-set-default",
    REPORT_SETTINGS_TEMPLATE_APPLY = "report-settings-template-apply",
    REPORT_SETTINGS_TEMPLATE_REMOVE = "report-settings-template-remove",
    REPORT_PACKAGE_EXPORT = "report-package-export",
    SENDING_DOMAIN_CREATE = "sending-domain-create",
    SENDING_DOMAIN_UPDATE = "sending-domain-update",
    SENDING_DOMAIN_VERIFY = "sending-domain-verify",
    SENDING_DOMAIN_DELETE = "sending-domain-delete",
    SENDING_EMAIL_CREATE = "sending-email-create",
    SENDING_EMAIL_UPDATE = "sending-email-update",
    SENDING_EMAIL_DELETE = "sending-email-delete",

    AGENT_RUN_START = "agent-run-start",
    AGENT_RUN_PAUSE = "agent-run-pause",
    AGENT_RUN_CONTINUE = "agent-run-continue",
    AGENT_RUN_STOP = "agent-run-stop",
    AGENT_RUN_INTERNAL_PATCH = "agent-run-internal-patch",
    AGENT_RUN_INTERNAL_CLAIM = "agent-run-internal-claim",
    AGENT_RUN_INTERNAL_USAGE = "agent-run-internal-usage",
    AGENT_RUN_INTERNAL_TOKEN_MINT = "agent-run-internal-token-mint",
    AGENT_RUN_INTERNAL_TOOL_CALLS = "agent-run-internal-tool-calls",
    AGENT_SKILL_CREATE = "agent-skill-create",
    AGENT_SKILL_UPDATE = "agent-skill-update",
    AGENT_SKILL_ENABLE = "agent-skill-enable",
    AGENT_SKILL_DISABLE = "agent-skill-disable",
    AGENT_SKILL_ARCHIVE = "agent-skill-archive",
    AGENT_SKILL_RESTORE = "agent-skill-restore",
    AGENT_SKILL_CHAT_EDIT = "agent-skill-chat-edit",
    AGENT_SKILL_RESET = "agent-skill-reset",
    AGENT_RUN_INTERNAL_ACTIVITY = "agent-run-internal-activity",
}

export enum ActivityProcessName {
    TRANSACTION_ENRICHMENT = "transaction-enrichment",
    TRANSACTION_COUNTERPARTY_ENRICHMENT = "transaction-counterparty-enrichment",
    TRANSACTION_ENRICHMENT_NORMALIZATION = "transaction-enrichment-normalization",
    TRANSACTION_SPLIT_RULE_APPLICATION = "transaction-split-rule-application",
    TRANSACTION_ENRICHMENT_SIDE_EFFECTS = "transaction-enrichment-side-effects",
}

export enum RPCProcessName {
    FINANCIAL_DOCUMENT_UPLOADED = "financial-document-uploaded",
    FINANCIAL_DOCUMENT_RETRY_MATCHING = "financial-document-retry-matching",
    INTEGRATION_ACCOUNT_CREATE_ACCOUNT = "integration-account-create-account",
    INTEGRATION_ACCOUNT_UPDATE_ACCOUNT = "integration-account-update-account",
    FINANCIAL_ACCOUNT_UPDATE_ACCOUNT = "financial-account-update-account",
    FINANCIAL_ACCOUNT_REMOVE_ACCOUNT = "financial-account-remove-account",
    UPDATE_TRANSACTION = "update-transaction",
    TRANSACTION_CHANGE_TO_PERSONAL = "transaction-change-to-personal",
    TRANSACTION_CHANGE_TO_BUSINESS = "transaction-change-to-business",
    TRANSACTION_ENHANCE = "transaction-enhance",
    TRANSACTION_REMOVE = "transaction-remove",
    MATCH_FINANCIAL_DOCUMENT = "match-financial-document",
    SYNC_PLAID_TRANSACTIONS = "sync-plaid-transactions",
    REMOVE_PLAID_CONNECTION = "remove-plaid-connection",
    ENTITY_REMOVE = "entity-remove",
}

export enum TestProcessName {
    TEST_RUN = "test-run",
    CATEGORIZATION_VIA_ML = "categorization-via-ml",
    SEED_TRANSACTION = "seed-transaction",
    CREATE_TRANSACTION = "create-transaction",
}

// Union type for type checking
export type ProcessName =
    | SQSProcessName
    | APIProcessName
    | TestProcessName
    | CLIProcessName;
